import GlobalContext from './GlobalContext';

export default GlobalContext;
export type { GlobalContextValue } from './GlobalContext';
export type { Locale } from '../../utils/intl/locale';
